// @ts-ignore
import Index from './src/Index.vue'
import {withInstall} from "../../utils/install";

Index.name = 'json-viewer';
export const JsonViewer = withInstall(Index);

export default JsonViewer;
